import {
  ACTIVE_SEARCH_TERM_ID,
  FOUND_NODE_CLASS_NAME,
  FOUND_WRAPPER_CLASS_NAME,
  DEFAULT_HIGHLIGHT_COLOR,
  ACTIVE_HIGHLIGHT_COLOR,
  MATCH_SCROLL_OFFSET_PX,
} from "./const";
import { ACCORDION_ANIMATION_TIMEOUT } from "../../../constants/ui";

import {
  scrollToElement,
  expandAccordion,
} from "../../../util/scrollToElement";

export const findActiveMatchDOM = (parent = document) =>
  parent.querySelector(`#${ACTIVE_SEARCH_TERM_ID}`);
export const findAllMatchesDOM = () =>
  document.getElementsByClassName(FOUND_NODE_CLASS_NAME);

export const makeActiveMatchDefault = (matchDOM) => {
  if (!matchDOM) {
    return;
  }

  matchDOM.removeAttribute("id");
  matchDOM.style.background = DEFAULT_HIGHLIGHT_COLOR;
};

export const makeDefaultMatchActive = (matchDOM) => {
  if (!matchDOM) {
    return;
  }

  matchDOM.setAttribute("id", ACTIVE_SEARCH_TERM_ID);
  matchDOM.style.background = ACTIVE_HIGHLIGHT_COLOR;
};

export const scrollToMatch = (matchDOM, scrolledParent = window) => {
  if (!matchDOM) {
    return;
  }
  const isInAccordion = expandAccordion(matchDOM);
  const timeout = isInAccordion ? ACCORDION_ANIMATION_TIMEOUT.in : 0;
  setTimeout(
    () =>
      scrollToElement(matchDOM, MATCH_SCROLL_OFFSET_PX, true, scrolledParent),
    timeout
  );
};

export const clearMatchesDOM = () => {
  const matchWrappers = document.getElementsByClassName(
    FOUND_WRAPPER_CLASS_NAME
  );
  while (matchWrappers.length) {
    const currentSpan = matchWrappers[0];
    const textNode = document.createTextNode(currentSpan.textContent);
    currentSpan.parentNode.replaceChild(textNode, currentSpan);
  }
};

export const highlightDOMMatches = (searchRegExp, nodes, indexToHighlight) => {
  let total = 0;
  nodes.forEach((node) => {
    const span = document.createElement("SPAN");
    span.classList.add(FOUND_WRAPPER_CLASS_NAME);
    span.innerHTML = node.nodeValue.replace(searchRegExp, function (
      localSearchTerm
    ) {
      total++;
      if (total === indexToHighlight + 1) {
        return `<span id="${ACTIVE_SEARCH_TERM_ID}" style="background:${ACTIVE_HIGHLIGHT_COLOR}" class="${FOUND_NODE_CLASS_NAME}">${localSearchTerm}</span>`;
      } else {
        return `<span style="background:${DEFAULT_HIGHLIGHT_COLOR}" class="${FOUND_NODE_CLASS_NAME}">${localSearchTerm}</span>`;
      }
    });
    node.parentNode.replaceChild(span, node);
  });
};
